var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonFlagIreland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "381px",
    height: "1954px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 381 1953",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .str1 {stroke:black;stroke-width:5.9035}\n    .str0 {stroke:black;stroke-width:8.85525}\n    .fil3 {fill:none}\n    .fil1 {fill:#009933}\n    .fil2 {fill:#FF6600}\n    .fil0 {fill:white}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_627200176"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "9,9 372,9 372,1944 192,1767 9,1944 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    transform: "matrix(-1.03886E-14 -0.342437 -1.14547 2.64845E-14 317.523 455.084)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    transform: "matrix(1.03202E-14 0.340182 -1.14547 2.64845E-14 317.523 193.538)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    transform: "matrix(9.62851E-15 0.317381 -1.14547 2.64845E-14 317.523 455.084)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3 str1",
    transform: "matrix(3.03374E-14 1 -1.14547 2.64845E-14 317.523 193.538)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    transform: "matrix(-1.03886E-14 -0.342437 -1.14547 2.64845E-14 317.523 1007.86)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    transform: "matrix(1.03202E-14 0.340182 -1.14547 2.64845E-14 317.523 746.317)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    transform: "matrix(9.62851E-15 0.317381 -1.14547 2.64845E-14 317.523 1007.86)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3 str1",
    transform: "matrix(3.03374E-14 1 -1.14547 2.64845E-14 317.523 746.317)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    transform: "matrix(-1.03886E-14 -0.342437 -1.14547 2.64845E-14 317.523 1549)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    transform: "matrix(1.03202E-14 0.340182 -1.14547 2.64845E-14 317.523 1287.46)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    transform: "matrix(9.62851E-15 0.317381 -1.14547 2.64845E-14 317.523 1549)",
    width: 383,
    height: 222
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3 str1",
    transform: "matrix(3.03374E-14 1 -1.14547 2.64845E-14 317.523 1287.46)",
    width: 383,
    height: 222
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonFlagIreland);
export default __webpack_public_path__ + "static/media/ribbon-flag-ireland.8e50568fd0e993cc2ca3d43f5a521112.svg";
export { ForwardRef as ReactComponent };